var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4444 13.2C15.8761 13.2001 17.2524 13.7473 18.2864 14.7275C19.3204 15.7078 19.9323 17.0453 19.9944 18.4613L20 18.7V19.8C20.0002 20.355 19.7884 20.8896 19.4072 21.2966C19.026 21.7036 18.5035 21.9529 17.9444 21.9945L17.7778 22H2.22222C1.66158 22.0002 1.12159 21.7906 0.710502 21.4132C0.299412 21.0358 0.0476037 20.5185 0.00555568 19.965L0 19.8V18.7C8.27139e-05 17.2827 0.552824 15.9201 1.54296 14.8964C2.53309 13.8728 3.88417 13.267 5.31444 13.2055L5.55556 13.2H14.4444ZM10 0C11.4734 0 12.8865 0.579463 13.9284 1.61091C14.9702 2.64236 15.5556 4.04131 15.5556 5.5C15.5556 6.95869 14.9702 8.35764 13.9284 9.38909C12.8865 10.4205 11.4734 11 10 11C8.52658 11 7.1135 10.4205 6.07163 9.38909C5.02976 8.35764 4.44444 6.95869 4.44444 5.5C4.44444 4.04131 5.02976 2.64236 6.07163 1.61091C7.1135 0.579463 8.52658 0 10 0Z",
    fill: "#B5B5B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.b0dd47f9310fe603b9bfb8c597fa8acd.svg";
export { ForwardRef as ReactComponent };